import {doc} from './docs.js';
import System5 from '../custom/System5.js';

doc(
    "system5",
    {
    },
    "Some system level controls over the subsequence");
export const system5 = (object) => {
    object.effect = new System5(object);

    return () => {
    };
};
